type BuyBtnProps = {
  text: string
  onClick?: () => void
  className?: string
}

const BuyBtn = ({ text, onClick, className }: BuyBtnProps) => {
  const handleBuyClick = () => {
    const buyUrl = import.meta.env.VITE_APP_URL_BUYPOOLX
    if (onClick) {
      onClick()
    } else {
      const newWindow = window.open(buyUrl, "_blank", "noopener")
      if (newWindow) {
        newWindow.opener = null
      }
    }
  }

  return (
    <button className={`flex-1 text-white bg-[#010013] rounded py-3 ${className}`} onClick={handleBuyClick}>
      {text}
    </button>
  )
}

export default BuyBtn
